export { appsignal, sendError } from './appsignal'
export { Masonry } from './masonry'
export { Scraper } from './scraper'
export { AutoMonetize } from './auto_monetize'
export { debug } from './configuration'

export function isPasswordValid(value, { minLength }) {
  return typeof value === 'string' && value.length >= minLength
}

export function scrollToTop({ top = 0, duration = 1000 }) {
  smoothScrollTo({ top, duration })
}

function smoothScrollTo({ top, duration }) {
  let startTime = null
  const start = window.scrollY

  function animationStep(currentTime) {
    if (!startTime) startTime = currentTime
    const timeElapsed = currentTime - startTime
    const progress = Math.min(timeElapsed / duration, 1)
    const computedTop = start + (top - start) * easeInOut(progress)

    window.scrollTo({ top: computedTop, behavior: 'smooth' })

    if (timeElapsed < duration) {
      window.requestAnimationFrame(animationStep)
    }
  }

  window.requestAnimationFrame(animationStep)
}

function easeInOut(value) {
  return value < 0.5 ? 2 * value * value : 1 - Math.pow(-2 * value + 2, 2) / 2
}

export function scrollTo(element, { offset = 0, duration = 1000 }) {
  const top = element.getBoundingClientRect().top + window.scrollY - offset
  smoothScrollTo({ top, duration })
}

export function isInViewport(element) {
  const rect = element.getBoundingClientRect()

  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
    rect.right <= (window.innerWidth || document.documentElement.clientWidth)
  )
}

// Remembers that the user closed an invitation (app download sheet, Android banner), so that the
// server stops rendering it. Listed in the cookie policy (legal/cookies). 13 months (395 days):
// the CNIL's ceiling for a cookie exempt from consent.
export function rememberDismissal(cookie) {
  document.cookie = `${cookie}=1; path=/; max-age=${60 * 60 * 24 * 395}; samesite=lax`
}

export function isDismissed(cookie) {
  return document.cookie.split('; ').includes(`${cookie}=1`)
}

export function waitForAnimations(element) {
  return Promise.all(element.getAnimations().map((animation) => animation.finished))
}

export const Browser = {
  get isTouchDevice() {
    return window.matchMedia('(pointer: coarse)').matches
  },

  get isAndroid() {
    return navigator.userAgent.match(/Android/i)
  },

  get isIOS() {
    return navigator.userAgent.match(/iPhone|iPad|iPod/i)
  },

  get isIpad() {
    return navigator.userAgent.indexOf('(iPad') > -1
  },

  get isIphone() {
    return navigator.userAgent.indexOf('(iPhone') > -1 || navigator.userAgent.indexOf('(iPod') > -1
  },

  get isSafari() {
    return !this.isChrome && navigator.userAgent.indexOf('Safari/') > -1
  },

  get isIosSafari() {
    return (this.isIpad || this.isIphone || navigator.maxTouchPoints > 2) && this.isSafari
  },

  get isChrome() {
    return navigator.userAgent.indexOf('Chrome/') > -1 || navigator.userAgent.indexOf('CriOS/') > -1
  },

  get isStandAlone() {
    return window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone
  },

  // Même détection que le hotwire_native_app? de turbo-rails.
  get isHotwireNative() {
    return /(Turbo|Hotwire) Native/.test(navigator.userAgent)
  },
}
